import { CgsEvent } from '@cgs/wge';

export class StopEvent extends CgsEvent {}
